
document.addEventListener('DOMContentLoaded', function () {

    $(".product-color-swatch-wrapper .swatch[data-id='44598506356936']").insertBefore($(".product-color-swatch-wrapper .swatch[data-id='44792871157960']"))
    $(".product-color-swatch-wrapper .swatch[data-id='44043747786952']").insertBefore($(".product-color-swatch-wrapper .swatch[data-id='44792871125192']"))

    function show_hide_color() {
        $('.product-color-swatch-wrapper .swatch').removeClass('hidden');
        $('.variant_list .variant_item .item:not(.active)').each(function () {
            const htmlContent = $(this).attr('data');
            $(this).parents('.variant_list').find(`.swatch[data*='${htmlContent}']`).addClass('hidden');
        });
    }
    show_hide_color();
    $('.product-color-swatch-wrapper .swatch').click(function () {
        $(this).addClass('active').siblings().removeClass('active');
        let variant_id = $(this).data('id');
        $(this)
            .parents('.top_wrapper')
            .find('.price_list')
            .find(`.price[data-id=${variant_id}]`)
            .addClass('active')
            .siblings()
            .removeClass('active');
        $(this)
            .parents('.product_item')
            .find(`.variant-img[data-id='${variant_id}']`)
            .removeClass('hidden')
            .siblings()
            .addClass('hidden');
        $(this).parents('.top_wrapper').find('add-cart-button').attr('data-variant-id', variant_id);
    });
    $('.variant_list .variant_item .item,.product_select .select_item .item').click(function () {
        if (!$(this).hasClass('active')) {
            $(this).addClass('active').siblings().removeClass('active');

            if ($(this).attr('data') == 'custom-item') {
                // $(this).parents('.top_wrapper').find('.square').hide();

                $(this).parents('.product_item').find('a').attr('href', $(this).data('url'));
                $(this).parents('.top_wrapper').find('.product_color_item').eq(0).removeClass('active');
                $(this).parents('.top_wrapper').find('.product_color_item').eq(1).addClass('active');
                $(this).parents('.top_wrapper').find('h3').eq(0).addClass('hidden');
                $(this).parents('.top_wrapper').find('h3').eq(1).removeClass('hidden');
                $(this).parents('.product_item').find('.custom_tag').eq(0).addClass('hidden');
                $(this).parents('.product_item').find('.custom_tag').eq(1).removeClass('hidden');
                $(this)
                    .parents('.top_wrapper')
                    .find(`.product_color_item.active .product-color-swatch-wrapper .swatch`)
                    .eq(0)
                    .click();
                if ($(this).parents('.product_item').hasClass('openfit2plus')) {
                    $(this).parents('.product_item').find('.variant_item').find('.item.active').text('USB-C')
                }
            } else {
                if ($(this).parents('.product_item').find('.product_color_item').length > 1) {
                    $(this).parents('.product_item').find('a').attr('href', $(this).parents('.product_info').data('url'));
                    $(this).parents('.top_wrapper').find('.square').show();
                    $(this).parents('.top_wrapper').find('.product_color_item').eq(1).removeClass('active');
                    $(this).parents('.top_wrapper').find('.product_color_item').eq(0).addClass('active');
                    $(this).parents('.top_wrapper').find('h3').eq(1).addClass('hidden');
                    $(this).parents('.top_wrapper').find('h3').eq(0).removeClass('hidden');
                    $(this).parents('.product_item').find('.custom_tag').eq(0).removeClass('hidden');
                    $(this).parents('.product_item').find('.custom_tag').eq(1).addClass('hidden');
                }
                if ($(this).parents('.product_item').hasClass('openfit2plus')) {
                    $(this).parents('.product_item').find('.variant_item').find('.item.active').text('USB-C + Wireless Charging')
                }

                if ($(this).attr('data') == 'No Adapter') {
                    $(this).parents('.top_wrapper').find('.square').hide();
                } else {
                    $(this).parents('.top_wrapper').find('.square').show();
                }
                show_hide_color();
                $(this)
                    .parents('.top_wrapper')
                    .find(`.product_color_item.active .product-color-swatch-wrapper .swatch:not(.hidden)`)
                    .eq(0)
                    .click();
            }
        }
    });

    $('.product_info .top_wrapper .title').click(function () {
        $(this).toggleClass('active')
        $(this).find('.product_select').slideToggle()
    })


    $('.product_info.opencomm2uc-2025-upgrade .variant_list .variant_values .item:first-child').click();
    $('.product_info.openfit2plus .variant_list .variant_values .item:first-child').click();

    $(".product-color-swatch-wrapper .swatch[data-id='44827943502024']").click()
    $(".product-color-swatch-wrapper .swatch[data-id='44043747786952']").click()
    $(".product-color-swatch-wrapper .swatch[data-id='44758320775368']").click()
    $(".product-color-swatch-wrapper .swatch[data-id='44602028687560']").click()
    $(".product-color-swatch-wrapper .swatch[data-id='44827942682824']").click()

    $(".products-card-item2 .product-color-swatch-wrapper .swatch[data-id='43714848653512']").click()
    $('.bottom_item .bottom_cart .add_btn,.slide_card .slide_bottom .add_btn').click(function () {
        $(this).parents('.bottom_item').find('add-cart-button').eq(0).click();
    });



    // 埋点
    $('.right_wrapper .product_item .product_top,.top_wrapper add-cart-button,.product_item .product_info a').click(
        function (e) {
            let sku, item_name, item_category3, price, index;
            let discount = 0;
            let button_name = $(this).text().trim();
            let event_name = 'select_item';
            if ($(this).hasClass('product_link')) {
                sku = $(this).attr('data-sku');
                // item_name = $(this).siblings('.title').text().trim();
                item_category3 = $(this).attr('data').split('/')[0];
                price = parseFloat($(this).data('price').trim().split('$')[1]);
                index = parseInt($(this).attr('data-index'));
            } else {
                let swatch = $(this).parents('.swiper-slide').find('.product_color_item.active .swatch.active');
                let price_active = $(this).parents('.swiper-slide').find('.price.active');
                sku = swatch.attr('data-sku');
                // item_name = '202508 labor day preheat productcard';
                item_category3 = swatch.attr('data').split('/')[0];
                price = parseFloat(price_active.find('.cur_price').text().trim().split('$')[1]);
                index = parseInt($(this).parents('.swiper-slide').index());
                if (price_active.find('.compare_price').length > 0) {
                    discount = Math.floor(
                        price_active.find('.compare_price').text().slice(1) - price_active.find('.cur_price').text().slice(1)
                    );
                }
            }
            if ($(this).hasClass('product_top')) {
                button_name = 'image';
            } else if ($(this).hasClass('add_cart')) {
                button_name = $(this).find('span').text();
                event_name = 'Add_To_Cart';
            } else {
                button_name = 'right arrow';
            }
            item_name = "page_boston-marathon_ProductList";
            window.dataLayer.push({ event_parameters: null });
            window.dataLayer.push({
                event: 'ga4Event',
                event_name: event_name,
                event_parameters: {
                    item_list_id: item_name,
                    item_list_name: item_name,
                    currency: 'USD',
                    button_name: button_name,
                    // module: $(this).parents('.fathers_day_products').find('h2').text(),
                    items: [
                        {
                            item_list_id: item_name,
                            item_list_name: item_name,
                            item_id: sku,
                            item_name: getProductInfo(sku).title,
                            discount: discount,
                            index: index,
                            item_category: getProductInfo(sku).name,
                            item_category2: getProductInfo(sku).size,
                            item_category3: item_category3,
                            item_variant: getProductInfo(sku).type,
                            item_brand: 'SHOKZ',
                            price: price,
                            quantity: 1,
                            currency: 'USD',
                        },
                    ],
                },
            });
        }
    );


    $('.product_item .product_info a').off('click').on('click', function () {
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'select_content',
            event_parameters: {
                content_type: 'Product Card',
                content_name: 'Boston_Marathon',
                button_name: 'Product_Card_Arrow',
            },
        });
    })
});

